// Copyright (c) 2018 Comsearch, Inc., All rights reserved

// NOTE - this is similar to the the Project Summary filterAndSortPaths
// However it has some big differences.
// - This is always sorting by a band (or 'no band')
// - This has different options in the select element
// - This does not have a 'contains empty value' checkbox like the Project Summary.
// This was intentionally separated from that logic to keep things clean.

import filterPaths from './filterPaths'
import sortPaths from './sortPaths'
import updateHighlighted from './updateHighlighted'

import { setBulkEditVisiblePathIds } from 'redux/modules/bulkEdit'

const filterAndSortPaths = () => (dispatch, getState) => {
  const bulkEditPaths = getState().bulkEdit.get('bulkEditPaths')

  const filteredPaths = dispatch(filterPaths(bulkEditPaths))
  const sortedPaths = dispatch(sortPaths(filteredPaths))

  const pathIds = sortedPaths.reduce((a, d) => {
    a.push(d.get('pathId'))
    return a
  }, [])

  dispatch(setBulkEditVisiblePathIds(pathIds))

  // since we might have highlighted paths/sites which are no longer visible,
  // update these
  return dispatch(updateHighlighted())
}

export default filterAndSortPaths
